module.exports = __webpack_public_path__ + "img/twitter-icon.e0321c52.svg";